export const CREATE_SBP_SUBSCRIPTION = 'lk/payment-methods/create-sbp'
export const CHANGE_STATUS_SUBSCRIPTION = 'lk/payment-methods/change-status-subscription'
export const CHECK_STATUS_SUBSCRIPTION = 'lk/payment-methods/status'
export const GET_PAY_METHODS = 'lk/payment-methods/banks'
export const DELETE_PAY_METHOD = 'lk/payment-methods/delete-sbp'
